import { render } from "./Inventory_Warehouse_Dialog.vue?vue&type=template&id=0b70d743&scoped=true&ts=true"
import script from "./Inventory_Warehouse_Dialog.vue?vue&type=script&lang=ts"
export * from "./Inventory_Warehouse_Dialog.vue?vue&type=script&lang=ts"

import "./Inventory_Warehouse_Dialog.vue?vue&type=style&index=0&id=0b70d743&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b70d743"]])

export default __exports__